export default __webpack_public_path__ + "static/media/ico-tokio.a3f7d49f.png";